<template>
  <div class="pink_bg">
    <div v-if="debug_show_page_name == true" style="color: green">
      page_0040_certificate_software_detail_bulk_edit
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-slot title="証書情報(一括編集）"> </title-and-slot>

      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-4">
          <button
            class="btn btn-primary"
            style="
              width: 25%;
              float: left;
              margin-left: -25px;
              min-width: 100px;
            "
            @click="backToList"
          >
            ＜　戻る
          </button>
        </div>
        <div class="col-xs-8">
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >
            更新日：{{ registrationDate }}
          </div>
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >
            登録日：{{ registrationDate }}
          </div>
        </div>


      </div>
      <div class="row" style="margin-bottom: 10px">
        承認状態：
        <input
          :disabled="readOnly"
          style="
            border: solid #337ab7 1px;
            width: 90px;
            padding-left: 4px;
            margin: 2px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
          "
          :value="approvalStatus"
        />
        状態:
        <select
          :disabled="readOnly"
          :value="Status"
          @change="Status = $event.target.value"
          class="status_field"
          :style="statusFieldStyle"
        >
          <option
            v-for="option in StatusOptions"
            :selected="option == Status"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
        申請No：
        <input
          type="button"
          style="
            border: solid #337ab7 1px;
            width: 140px;
            padding-left: 4px;
            margin: 2px;
            margin-bottom: -6px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
            color: #008cff;
            text-decoration: underline;
          "
          :value="approvalHistoryTorokuNumber"
        />
      </div>
      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-12" style="padding: 0px; margin: -15px">
          <h3>ソフトウェア情報</h3>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        <div class="row" style="margin-bottom: 10px">
          <div class="col-xs-6" style="">
            <!-- Coll A<br> -->
            <field-box
              v-for="f in formFields.col1"
              v-bind:key="f.id"
              v-bind:data="f"
              :read="readOnly"
              :val="values[f.id]"
            ></field-box>
          </div>
          <div class="col-xs-6" style="">
            <field-box
              v-for="f in formFields.col2"
              v-bind:key="f.id"
              v-bind:data="f"
              :read="readOnly"
              :val="values[f.id]"
            ></field-box>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        <button
          v-show="disableApplicationBtn == true"
          :disabled="checkUserPermission(true, permissionMode.EDIT) == false"
          class="btn btn-primary on_confirm_execute_process_btn"
          @click="onConfirmExecuteProcess"
        >
          申請
        </button>
        <button
          v-show="isAdminSavingApplication == false || true"
          v-if="read_only == false"
          :disabled="
            disableAllButtons ||
            checkUserPermission(true, permissionMode.EDIT) == false
          "
          class="btn btn-primary on_local_save_certificate_software"
          @click="onLocalSaveBulkCertificateSoftware"
        >
          下書保存
        </button>
        <button v-else class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="onEdit" >編集</button>
        
      </div>

    </div>

    <certificate-information-connection-application-modal
      tag="showBulkImportConfimationModal"
    />
    <confirmation-modal
      tag="confirmUnlinkDevices"
      @done="onConfirmUnlinkDevices"
    />

    <confirmation-modal
      tag="onLocalSaveCertificateSoftwareAfterValudateStatusCheck"
      @done="onDeviceEmbeddedInformationAddCheckConfirmStep2"
    />


    <confirmation-modal
      tag="notificationCertificcateBulkAfterSave"
      @done="afterTheNotificationAfterSave"
    />

    <application-confirmation-modal
      tag="certificateBulkApplicationConfimationModal"
    />

    <confirmation-modal
      tag="deleteCertificateInformationDetailModal"
      @done="onConfirmDelete"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import _ from 'lodash';
import { fields, filed_types } from "@/rules/fields_certificate_software";
import bulkImportConfirmationModal from "@/components/modals/certificate-information-connection-application-modal";
import applicationConfirmationModal from "@/components/modals/application-confirmation-modal";
import { utils } from "@/libs/utils";
import _debug from "debug";
var mdebug = _debug("esma:device_certificate_software");
import fieldBoxes from "@/components/form-field";
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

import changeHistoryModal from "@/components/modals/change-history-modal";
import certificateSoftwareLinkedUpgradeModal from "@/components/modals/certificate-software-linked-upgrade-modal";


import constants from "@/rules/constants";

var timeout_control = {};
var queue_bus = [];

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "field-box": fieldBoxes,
    "certificate-information-connection-application-modal": bulkImportConfirmationModal,
    "application-confirmation-modal": applicationConfirmationModal,
    "change-history": changeHistoryModal,
    "certificate-software-linked-upgrade-modal": certificateSoftwareLinkedUpgradeModal,
  },
  data() {
    return {
      show_sub_table_associated_device: false,
      api_name: "certificate_software",
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      page_acl: acl.certificate_software,
      approval_history_id: "",
      approval_id: null,
      local_status: false,
      save_edit_cliqued: false,
      local_seq_id: -1,
      approval_history_toroku_number: false,
      allow_surplus: false,
      is_surplus: false,
      is_approved: false,
      load_upgrade_modal: false,
      force_disable_due_upgrade_destination: false,
      form_confirmation: {},
      enable_history_modal: false,
      show_surplus_alert_message: false,
      company_selection_started: false,
      disable_application_btn:false
    };
  },
  computed: {
    disableApplicationBtn:{
      get(){
        return this.disable_application_btn;
      },
      set(v){
        this.disable_application_btn = v;
      }
    },
    showSurplusAlertMessage: {
      get() {
        return this.show_surplus_alert_message;
      },
      set(v) {
        this.show_surplus_alert_message = v;
      },
    },

    forceDisableDueUpgradeDestination: {
      get() {
        return this.force_disable_due_upgrade_destination;
      },
      set(v) {
        this.force_disable_due_upgrade_destination = v;
      },
    },
    loadUpgradeModal: {
      get() {
        return this.load_upgrade_modal;
      },
      set(v) {
        this.load_upgrade_modal = v;
      },
    },
    statusFieldStyle() {
      if (
        this.$store.state["current_field_style"] &&
        this.$store.state["current_field_style"]["status"]
      ) {
        return this.$store.state["current_field_style"]["status"];
      } else {
        return "";
      }
    },
    isApproved: {
      get() {
        return this.is_approved;
      },
      set(v) {
        this.is_approved = v;
      },
    },
    isSurplus: {
      get() {
        return this.is_surplus;
      },
      set(v) {
        this.is_surplus = v;
      },
    },
    allowSurplus: {
      get() {
        return this.allow_surplus;
      },
      set(v) {
        this.allow_surplus = v;
      },
    },
    subTableController: {
      get() {
        return this.sub_table_controller;
      },
      set(v) {
        this.sub_table_controller = v;
      },
    },
    disableAllButtons() {
      return this.loadBy == "certificate_software_number";
    },
    localSeqId: {
      get() {
        return this.local_seq_id;
      },
      set(v) {
        this.local_seq_id = v;
      },
    },
    // About to hide or show the buttons start
    disableEditMainBtn() {
      //編集 (edit main)
      if (this.loadBy == "fk_id") {
        return this.hideForApplicant && this.approvalStatus == "申請中";
      }
      return this.approvalStatus == "申請中";
    },

    disableCopyMainBtn() {
      //コピー
      return false; // There is no condition to hide Copy
    },
    hideForApplicant() {
      if (this.loadBy != "fk_id") {
        return false;
      }
      if (
        typeof this.$store.state[this.stateCurrentRow][
          "approval_history_next_approver"
        ] == "undefined" &&
        this.isAdmin == true
      ) {
        return false;
      } else {
        //                                               user is the applicant                                     and            user is not the next approver the  hide
        return (
          this.$store.state[this.stateCurrentRow][
            "approval_history_applicant"
          ] == Vue.localStorage.get("userID") &&
          this.$store.state[this.stateCurrentRow][
            "approval_history_next_approver"
          ] != Vue.localStorage.get("userID")
        );
      }
    },
    hideEditMainBtn() {
      // 編集 (edit main)
      return this.hideForApplicant && this.approvalStatus == "申請中";
    },

    hideCopyMainBtn() {
      //コピー
      return this.loadBy == "fk_id" || this.is_new == true;
    },
    hideApplicationBtn() {
      //申請/Application
      return (
        (this.loadBy == "fk_id" && this.approvalStatus != "下書中") ||
        this.approvalStatus != "下書中"
      );
    },
    hideApplyConfirmationBtn() {
      //確認/Confirmation
      if (this.loadBy != "fk_id") {
        return true;
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn() {
      //差戻/Reject
      //this.loadBy == 'fk_id'
      return this.loadBy != "fk_id" || this.approvalStatus != "申請中";
    },
    // About to hide or show the buttons end
    Deadline_Alert: {
      // FIXME: This fields are not goog, it is used as copy and paster, but there are a log or unecessary code
      get() {
        if (this.local_status === false) {
          return (
            this.$store.state[this.stateCurrentEditing]["deadline_alert"] || ""
          );
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "deadline_alert"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "deadline_alert"
        ] = this.local_status = v;
      },
    },
    Comprehensive_contract: {
      get() {
        if (this.local_status === false) {
          return (
            this.$store.state[this.stateCurrentEditing][
              "comprehensive_contract"
            ] || ""
          );
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "comprehensive_contract"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "comprehensive_contract"
        ] = this.local_status = v;
      },
    },
    Downgrade: {
      get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentEditing]["downgrade"] || "";
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "downgrade"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "downgrade"
        ] = this.local_status = v;
      },
    },
    Status: {
      get() {
        if (this.local_status === false) {
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        } else {
          return this.local_status;
        }
      },
      set(v) {
        this.$store.state[this.stateCurrentRow][
          "status"
        ] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing][
          "status"
        ] = this.local_status = v;
      },
    },
    StatusOptions() {
      var options = _.clone(fields.status.options);
      if (this.allowSurplus == true) {
        if (options.indexOf("余剰") < 0) {
          options.push("余剰");
        }
      }
      return options;
    },

    subTableDeviceEmbeddedInformationStyle() {
      if (this.saveEditClicked || this.is_new == false) {
        return "";
      } else {
        return "opacity: 0.5;";
      }
    },
    saveEditClicked: {
      get() {
        return this.save_edit_cliqued;
      },
      set(v) {
        this.save_edit_cliqued = v;
      },
    },
    approvalHistoryId: {
      get() {
        return this.approval_history_id;
      },
      set(v) {
        this.approval_history_id = v;
      },
    },
    approvalHistoryTorokuNumber: {
      get() {
        return this.approval_history_toroku_number;
      },
      set(v) {
        this.approval_history_toroku_number = v;
      },
    },
    isAdminSavingApplication() {
      return this.isAdmin && this.loadBy == "fk_id";
    },
    showFieldchangedStyle() {
      return (
        (this.$store.state[this.stateCurrentRow]["approval_status"] ==
          "申請中" ||
          this.$store.state[this.stateCurrentRow]["approval_status"] ==
            "差戻") &&
        (this.isAdmin ||
          this.$store.state[this.stateCurrentRow][
            "approval_history_next_approver"
          ])
      );
    },
    approvalStatus() {
      return (
        this.$store.state[this.stateCurrentEditing]["approval_status"] ||
        this.$store.state[this.stateCurrentRow]["approval_status"]
      );
    },
    allowEditjurisdictionSystem() {
      return (
        this.$store.state[this.stateCurrentRow][
          "jurisdiction_classification"
        ] != "IT所管システム"
      );
    },
    aprovalId: {
      get() {
        return this.aproval_id;
      },
      set(v) {
        this.aproval_id = v;
      },
    },

    certificateSoftwareNumber() {
      return this.$store.state[this.stateCurrentRow][
        "certificate_software_number"
      ];
    },

    certificateSeqId() {
      return parseInt(
        this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId
      );
    },
    deviceControlNumber() {
      return this.$store.state[this.stateCurrentRow]["device_control_number"];
    },
    registrationDate() {
      return utils.format_date(
        this.$store.state[this.stateCurrentRow]["registration_date"]
      );
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1: [
          utils.extend(_.clone(fields.certificate_software_number), { disabled: true, read_only: true, }),
          utils.extend(_.clone(fields.maker), {disabled: true, read_only: true,error_if_blank:false }),
          utils.extend(_.clone(fields.software_name), {disabled: true, read_only: true,error_if_blank:false,}),
          utils.extend(_.clone(fields.company), {error_if_blank:false}), // This one need to be handled separated
          utils.extend(_.clone(fields.licensed_department), {error_if_blank:false}),
          utils.extend(_.clone(fields.license_jurisdiction_team), {error_if_blank:false}),
          utils.extend(_.clone(fields.license_name), {error_if_blank:false}),
          utils.extend(_.clone(fields.jurisdiction_classification), {
            error_if_blank:false,
            on_set_value: (data) => {
              this.singleTimeout(
                "upd_license_jurisdiction_system_it",
                setTimeout(() => {
                  this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                    val: data == "IT所管システム",
                  });
                }, 500)
              );
              setTimeout(() => {
                this.queuedBusEmit("upd_license_jurisdiction_system", {
                  val: data == "EUC・その他",
                });
              }, 100);
            },
          }),
          utils.extend(_.clone(fields.license_jurisdiction_system), {
            error_if_blank:false,
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;",
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_it",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],
          }),
          utils.extend(_.clone(fields.equipment_in_charge_system), {
            error_if_blank:false,
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;",
            listen_for: [
              {
                name: "upd_license_jurisdiction_system",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],
          }),
          utils.extend(_.clone(fields.product_key), {disabled: true, read_only: true,}),
          utils.extend(_.clone(fields.upgrade), {disabled: true, read_only: true,}),
          utils.extend(_.clone(fields.upgrade_source), {
            error_if_blank:false,
            disabled: true, read_only: true,
            force_readonly: true,
            field_style: " width: 100%;display: block;",
            buttons: [
              {
                btn_style:
                  "width:250px;margin-left:2px;padding-left: 1px;padding-right: 1px;float:left; margin-top: 2px;margin-bottom: 10px;    background: rgb(51 122 183);border-color: rgb(46 109 164);",
                type: "callback",
                callback: (b) => {
                  // this.selectUpgradeCertificate();
                },
                label: "アップグレード元の証書を選択する", // Need the spec.
              },
            ],
          }),
        ],
        col2: [
          utils.extend(_.clone(fields.upgrade_destination), {disabled: true,read_only: true,}),
          utils.extend(_.clone(fields.deadline_alert), {
            disabled: this.isSurplus,
            read_only: this.isSurplus,
            on_set_value: (data) => {
              setTimeout(() => {
                this.queuedBusEmit("upd_expiration_date", {
                  val: data == "有",
                });
              }, 100);
            },
          }),
          utils.extend(_.clone(fields.expiration_date), {
            listen_for: [
              {
                name: "upd_expiration_date",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],
          }),
          utils.extend(_.clone(fields.maintenance_deadline), {
            disabled: this.isSurplus,
            read_only: this.isSurplus,
          }),
          utils.extend(_.clone(fields.second_number), {disabled: true, read_only: true,}),
          utils.extend(_.clone(fields.unlimited), {disabled: true, read_only: true,}),
          utils.extend(_.clone(fields.license), {disabled: true, read_only: true,error_if_blank:false}),
          utils.extend(_.clone(fields.applicant_name), {error_if_blank:false}),
          utils.extend(_.clone(fields.management_person_name), {error_if_blank:false}),
          utils.extend(_.clone(fields.comprehensive_contract), {disabled: true, read_only: true, error_if_blank:false}),
          utils.extend(_.clone(fields.effective_number), { disabled: true, read_only: true, }),
          utils.extend(_.clone(fields.remaining_number), { disabled: true, read_only: true, }),
          utils.extend(_.clone(fields.remark), { label_length_4: true }),
        ],
        col3: [],
      };
    },
    loadBy() {
      return this.$route.meta.load_by;
    },
  },
  methods: {
    queuedBusEmit(id, data) {
      queue_bus.push({ id, data });
      this.queuedBusRun();
    },
    queuedBusRun() {
      if (queue_bus.length > 0) {
        if (timeout_control["bus"]) {
          return;
        }
        timeout_control["bus"] = setTimeout(() => {
          var n = queue_bus.shift();
          bus.$emit(n.id, n.data);
          timeout_control["bus"] = false;
          this.queuedBusRun();
        }, 50);
      } else {
      }
    },
    singleTimeout(name, ev) {
      if (timeout_control[name]) {
        clearTimeout(timeout_control[name]);
      }
      timeout_control[name] = ev;
    },
    onEdit(){
      mdebug("onEdit")
      setTimeout(() => {
        this.disableApplicationBtn = false;
        this.read_only = false;
      }, 300);
    },
    onDelete() {
      bus.$emit("deleteCertificateInformationDetailModal", {
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color: "danger",
        no_color: "info",
        model_height: "50",
      });
    },
    onConfirmDelete(mode) {
      if (mode == "yes") {
        this.commonDelete(this);
      }
    },

    onConfirmExecuteProcess() {
      var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);
      try {
        list_seq_id = JSON.parse(list_seq_id)
        var syubetu = constants.SYUBETU.CERTIFICATE
        bus.$emit("certificateBulkApplicationConfimationModal",{
          list_seq_id:list_seq_id.arr,
          application_mode:"bulk_edit_certificate",
          title_prefix:""+syubetu+"(一括編集）",
          title_suffix:""+syubetu+"(一括編集）",
          process_import_url:'/' + this.api_name + '/bulk_to_approval_history/',
          on_finish_url_name:"page_0040_certificate_software",
          ref_id:null,
        });
      } catch (error) {
        this.$notify({
          title: "適用する行の読込に失敗しました。",
          text:error,
          type: 'error',
          duration: 12000
        })
      }
 
    },
   
    processFieldStyle(store_key_name, last_changed_fields) {
      if (Array.isArray(last_changed_fields)) {
        last_changed_fields.forEach((e) => {});
      } else {
      }
      this.$store.state[store_key_name] = {};
      if (
        last_changed_fields &&
        last_changed_fields != null &&
        last_changed_fields.length > 0
      ) {
        last_changed_fields.forEach((f) => {
          if (this.showFieldchangedStyle) {
            this.$store.state[store_key_name][f] = ";color:red;";
          }
        });
      }
    },

    onDeviceEmbeddedInformationAddCheckConfirmStep2(mode) {
      console.log("onDeviceEmbeddedInformationAddCheckConfirmStep2", mode);
      if(mode == "yes"){
        this.read_only = false;
      // if ( this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" && this.loadBy == "fk_id" ) {
      //   // It is in approving proccess, and in this case should not chang ethe status to draft
      // } else {
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
      // }

        var list_seq_id = Vue.localStorage.get('bulk_edit_' + this.local_page_id);

       try {
          list_seq_id = JSON.parse(list_seq_id)
          var disabled_fields = []
          this.allFields.forEach(f=>{
            if(f.ref_field && ((f.ref_field.data && f.ref_field.data.disabled == true)  || (f.ref_field.localDisabled == true))){
              disabled_fields.push(f.id)
            }
          })
          this.saveBulk(this.api_name,list_seq_id.arr, { from_edit_form: true ,se_transaction: true, disabled_fields}, (err)=>{
            // this.showApplyButton = true;
            // this.approvalStatus = "下書中"; // It will show the Apply button
            this.disableApplicationBtn = true
            bus.$emit("notificationCertificcateBulkAfterSave", {
              message: "",
              title: "登録情報を下書きに保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color: "",
              no_color: "",
              model_height: "50",
            });
            this.read_only = true;
            //Bellow code will copy the data  from stateCurrentEditing to stateCurrentRow
            setTimeout(() => {
              var temp_current = _.clone(this.$store.state[this.stateCurrentRow])
              var temp = _.clone(this.$store.state[this.stateCurrentEditing])
              this.allFields.forEach(f=>{
                if(typeof temp[f.id] == "undefined" ){
                  temp[f.id] = temp_current[f.id] || "";
                }
              })
              this.$store.state[this.stateCurrentRow] = temp
              this.$store.state[this.stateCurrentEditing] = temp
            }, 50); 
          })
        } catch (error) {
          this.$notify({
            title: "予期しないエラーが発生し、登録が行えません",
            text:error,
            type: 'error',
            duration: 12000
          })
        }


      }
    },
    onDeviceEmbeddedInformationAddCheckConfirm(mode) {
      if (mode == "yes") {
        this.onDeviceEmbeddedInformationAddCheckConfirmStep2(mode);
      }
    },

    afterTheNotificationAfterSave(mode) {
      if (mode == "no" || mode == "yes") {

      }
    },

    onSave() {
      this.read_only = false;
      this.commonSaveInfo(this, this.api_name, {});
    },

    backToList() {
      var certificate_back_to_list = window.sessionStorage.getItem(
        "certificate_back_to_list"
      );
      if (this.loadBy == "fk_id") {
        return this.$router.push({
          name: "page_0050_approval_history_tabs",
          params: {},
        });
      } else if ((certificate_back_to_list || "").indexOf("/") == 0) {
        return this.$router.push(certificate_back_to_list);
      } else {
        return this.$router.push({
          name: "page_0040_certificate_software",
          params: {},
        });
      }
    },
    onLocalSaveBulkCertificateSoftware() {
      // this.form_confirmation = {};
      // this.commonValidateFields(this, {}, (error_found) => {
        // if (error_found != false) {
        //   return;
        // }
        var status = this.getFieldLastValue("status");
        var effective_number = this.getFieldLastValue("effective_number");
        if (status == "廃棄" && effective_number > 0) {
          bus.$emit("confirmUnlinkDevices", {
            message:
              "機器に紐づいたソフトウェア情報を廃棄します。<br>紐付けを解除してよろしいですか？",
            title: "",
            yes_label: "はい(紐付けを解除して下書保存)",
            no_label: "キャンセル",
            yes_color: "primary",
            no_color: "",
            model_height: "50",
            model_width: "500px",
          });
        } else {
          this.onLocalSaveCertificateSoftwareAfterValudateStatus();
        }
      // });
    },

    onConfirmUnlinkDevices(mode) {
      if (mode == "yes") {
        this.form_confirmation["confirm_clear_device"] = "yes";
        this.onLocalSaveCertificateSoftwareAfterValudateStatus();
      }
    },
    onLocalSaveCertificateSoftwareAfterValudateStatus() {
      if (this.is_new == false) {
        this.saveEditClicked = true;
      }
      console.log("onLocalonLocalSaveCertificateSoftwareAfterValudateStatusSave");
      bus.$emit("onLocalSaveCertificateSoftwareAfterValudateStatusCheck", {
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "下書保存",
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
      });
    },


    prepareCompanySelection(
      companies,
      department_and_team,
      company_field,
      department_field,
      team_field,
      company_field_name,
      department_field_name
    ) {
      var selected_company = false;
      var selected_department = false;
      company_field.page_controller_setup({
        on_select: (_selected_company) => {
          selected_company = _selected_company;
          if (selected_company == "") {
            department_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "disable" });
          } else {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            departments.unshift("");
            department_field.page_controller_msg({ cmd: "enable" });
            department_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
            team_field.page_controller_msg({ cmd: "disable" });
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: true,
            });
          }
        },
      });
      department_field.page_controller_setup({
        on_select: (_selected_department) => {
          selected_department = _selected_department;
          if (selected_department == "") {
            team_field.page_controller_msg({ cmd: "disable" });
            team_field.page_controller_msg({ cmd: "set_value", val: "" });
          } else {
            var teams = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return (
                    d.company == selected_company &&
                    d.department == selected_department
                  );
                }) || [],
                "team"
              ) || []
            );
            teams.unshift("");
            team_field.page_controller_msg({ cmd: "enable" });
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({
              cmd: "set_options",
              options: teams,
              reset: true,
            });
          }
        },
      });
      company_field.page_controller_msg({
        cmd: "set_options",
        options: _.clone(companies),
      });
      company_field.page_controller_msg({ cmd: "disable" });
      department_field.page_controller_msg({ cmd: "disable" });
      team_field.page_controller_msg({ cmd: "disable" });
 

      setTimeout(() => {
        department_field.page_controller_msg({cmd:"enable_if_data"})
        team_field.page_controller_msg({cmd:"enable_if_data"})
        selected_company = this.$store.state[this.stateCurrentRow][company_field.id]
        selected_department = this.$store.state[this.stateCurrentRow][department_field.id]
        if(selected_company && selected_company.length > 0){
          department_field.page_controller_msg({ cmd: "enable" });
          var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
          department_field.page_controller_msg({cmd:"set_options",options:departments, reset:false})
          if(selected_department && selected_department.length > 0){
            var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company &&  d.department == selected_department})||[],"team")||[]);
            team_field.page_controller_msg({cmd:"set_options",options:teams, reset:false})
          }
        }
        var slUserCompany = Vue.localStorage.get("userCompany") || false;
        if(slUserCompany && slUserCompany.indexOf("MH") == 0){
          company_field.page_controller_msg({cmd:"set_value",val:slUserCompany})
        }else if(slUserCompany && slUserCompany.indexOf("ライセンス管理窓口") == 0){
          console.log('TEST DEBUG 210429 (410 at page_0010_device_embedded_information_detail_bulk_edit.vue)[16:08]: try to enable', {  });
          company_field.page_controller_msg({cmd:"enable"})
        }

      }, (this.is_new)?500:600);

      setTimeout(
        () => {
          department_field.page_controller_msg({ cmd: "enable_if_data" });
          team_field.page_controller_msg({ cmd: "enable_if_data" });

          selected_company = this.$store.state[this.stateCurrentRow][
            company_field_name
          ];
          selected_department = this.$store.state[this.stateCurrentRow][
            department_field_name
          ];
          if (selected_company && selected_company.length > 0) {
            var departments = _.uniq(
              _.map(
                _.filter(department_and_team || [], (d) => {
                  return d.company == selected_company;
                }) || [],
                "department"
              ) || []
            );
            department_field.page_controller_msg({
              cmd: "set_options",
              options: departments,
              reset: false,
            });
            if (selected_department && selected_department.length > 0) {
              var teams = _.uniq(
                _.map( _.filter(department_and_team || [], (d) => { return ( d.company == selected_company && d.department == selected_department ); }) || [], "team" ) || []
              );
              team_field.page_controller_msg({
                cmd: "set_options",
                options: teams,
                reset: false,
              });
            }
          }

        },
        this.is_new ? 100 : 500
      );
    },
    startCompanySelection() {
      if (this.company_selection_started == true) {
        return;
      }
      this.company_selection_started = true;
      if (true) {
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued(
          "/master_company/list_company_name",
          {},
          (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
            var companies = [""];
            _companies.forEach((c) => {
              companies.push(c.val);
            });
            // Load the departments and teams
            this.$ajax.post_cached_queued(
              "/master_belongs/list_team_and_department",
              {},
              (err, department_and_team) => {
                if (err) {
                  this.$notify({
                    title: "部署・チームのデータの読込に失敗しました。",
                    text: err,
                    type: "error",
                    duration: 10000,
                  });
                  return;
                }
                this.prepareCompanySelection(
                  _.clone(companies),
                  _.clone(department_and_team),
                  temp_fields.company,
                  temp_fields.licensed_department,
                  temp_fields.license_jurisdiction_team,
                  "company",
                  "department"
                );
                if (this.$route.params.seq_id == "new") {
                  var default_company = Vue.localStorage.get(
                    temp_fields.company.default_from_local_storage
                  );
                  if (default_company != constants.COMPANY.ALL) {
                    setTimeout(
                      () => {
                        var default_deparment = Vue.localStorage.get(
                          temp_fields.licensed_department
                            .default_from_local_storage
                        );
                        var default_team = Vue.localStorage.get(
                          temp_fields.license_jurisdiction_team
                            .default_from_local_storage
                        );
                        temp_fields.company.page_controller_msg({
                          cmd: "set_value",
                          val: default_company,
                        });
                        temp_fields.licensed_department.page_controller_msg({
                          cmd: "set_value",
                          val: default_deparment,
                        });
                        temp_fields.license_jurisdiction_team.page_controller_msg(
                          { cmd: "set_value", val: default_team }
                        );
                      },
                      this.is_new ? 300 : 1000
                    );
                  }
                }
              }
            );
          }
        );
      }
    },
  },
  mounted() {
    this.Status = ""
    this.addHtmlClass(document.body,'blue_bg')
    this.disableApplicationBtn = false;
    this.local_page_id = this.$route.params.p_id;
    this.is_new = true;
    // Note, it is not editing a new record, but will emulate it, as the behaivour is the same.
    this.allFields.forEach((f) => {
      this.$store.state[this.stateCurrentRow][f.id] = "";
    });
    this.startCompanySelection();
    setTimeout(() => {
      this.Status = ""
      this.$store.state[this.stateIsEditingNew] = true;
      this.read_only = false;
      this.is_new = true;
    }, 300);


    },
  beforeDestroy() {
    this.Status = ""
    this.removeHtmlClass(document.body,'blue_bg')
    var store_style = (this.$store.state[
      this.stateCurrentRow.replace("current_row", "current_field_style")
    ] = {});
  },
  beforeMount() {
    this.Status = ""
  },
};
</script>
<style scoped>
.surplus_msg {
  color: red;
  margin: 20px 0px 20px -10px;
  font-weight: bold;
}
.status_field {
  border: solid #337ab7 1px;
  width: 90px;
  padding-left: 4px;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
}
.on_local_save_certificate_software {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: -10px;
}
.btn_cancel_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #a6a6a6;
}
.on_edit_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  margin-right: -10px;
}
.process_approval_approve_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #92d050;
  border-color: #92d050;
}
.process_approval_cancel_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #ff7c80;
  border-color: #ff7c80;
}
.on_confirm_execute_process_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #92d050;
  border-color: #92d050;
}
.clone_record_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
}
.show_device_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  _background: #a6a6a6;
  _border-color: #a6a6a6;
}
.show_history_btn {
  min-width: 100px;
  width: 7%;
  float: right;
  margin-right: 10px;
  background: #a6a6a6;
  border-color: #a6a6a6;
}
.bottom_tab {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input {
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left: 4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_software_detail_bulk_edit.vue?41f58e30